import Service from "../Service";
const resource = "TicEquipmentLicense/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID },
    });
  },
  saveMassive(cmp, requestID) {
    return Service.post(resource + "saveMassive", cmp, {
      params: { requestID },
    });
  },
  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID },
    });
  },
  listDevicesHistory(parameters, requestID) {
    return Service.post(resource + "listDevicesHistory", parameters, {
      params: { requestID },
    });
  },
  SaveHistoryLicense(parameters, requestID) {
    return Service.post(resource + "SaveHistoryLicense", parameters, {
      params: { requestID },
    });
  },
};
